const LevelDetails = {
  1: {
    image: "https://res.cloudinary.com/dg2yejdpt/image/upload/v1470597072/DC.jpg",
    name: "National Mall, Washington, DC"
  },
  2: {
    image: "https://res.cloudinary.com/dg2yejdpt/image/upload/v1470597072/grand_canyon.jpg",
    name: "Grand Canyon National Park"
  },
  3: {
    image: "https://res.cloudinary.com/dg2yejdpt/image/upload/v1470597072/yellowstone.jpg",
    name: "Yellowstone National Park"
  },
  4: {
    image: "https://res.cloudinary.com/dg2yejdpt/image/upload/v1470605787/Serengeti.jpg",
    name: "Serengeti National Park, Tanzania"
  },
  5: {
    image: "https://res.cloudinary.com/dg2yejdpt/image/upload/v1470605849/coney_island.jpg",
    name: "Coney Island Boardwalk, NYC"
  },
  6: {
    image: "https://res.cloudinary.com/dg2yejdpt/image/upload/v1470597072/yosemite.jpg",
    name: "Yosemite National Park"
  },
  7: {
    image: "https://res.cloudinary.com/dg2yejdpt/image/upload/v1470597072/yosemite.jpg",
    name: "Yosemite National Park 2"
  }
};

module.exports = LevelDetails;



/** WEBPACK FOOTER **
 ** ./lib/level_details.js
 **/